import { parseBigintRouteParam } from '@client/utils/routing/parse-bigint-route-param';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

// Legacy public lodgement URL, still embedded on insurers' own websites. Redirect at the
// router level: rendering `<Navigate>` as this route's component is the max-update-depth
// footgun (client/CLAUDE.md → "Index Route Redirects") and delays the target route's
// `beforeLoad` prefetches by a full render cycle.
export const Route = createFileRoute('/public/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId')({
    validateSearch: zodValidator(z.object({ data: z.string().optional() })),
    params: {
        parse: (params) => ({
            orgId: parseBigintRouteParam(params.orgId),
            pdsVersionId: parseBigintRouteParam(params.pdsVersionId),
            questionnaireId: parseBigintRouteParam(params.questionnaireId),
            productTypeId: parseBigintRouteParam(params.productTypeId),
        }),
    },
    beforeLoad: ({ params, search }): never => {
        throw redirect({
            to: '/public/$orgId/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId',
            params,
            search,
            replace: true,
        });
    },
});
